import { useCallback, useMemo } from 'react';
import Amplitude from 'utils/amplitude';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { useDefaultAccountPicker } from './useDefaultAccountPicker';
export const usePayQuickCTAs = (source) => {
    const navigation = useMainStackNavigation();
    const [, picker] = useDefaultAccountPicker();
    const startPayment = useCallback(async (flow) => {
        const result = await picker();
        if (result) {
            Amplitude.logEvent('Start Payment', {
                amount: null,
                type: flow === 'pay' ? 'direct' : 'request',
                source,
            });
            navigation.navigateDeprecated('PayRequestScreen', { flow });
        }
    }, [picker, navigation, source]);
    return useMemo(() => ({
        onPressPay: () => startPayment('pay'),
        onPressRequest: () => startPayment('request'),
        onPressTransfer: () => navigation.navigateDeprecated('Transfer'),
        onPressActivity: () => navigation.navigateDeprecated('ActivityScreen'),
    }), [startPayment, navigation]);
};
